import { makeAutoObservable, computed } from "mobx";

import { ItemListItemKind } from "@/components/item-list/types";
import { AppStore } from "@/store";
import { FloatingNotePreview } from "./floating-note-preview";
import { ItemPreviewHoveringState } from "./item-preview-hovering-state";
import { IItemPreviewState } from "./item-preview.types";

export class ItemPreviewState implements IItemPreviewState {
  private store: AppStore;
  private id: string;
  private kind: ItemListItemKind;
  private hoveringOverTarget: ItemPreviewHoveringState;
  private hoveringOverPreview: ItemPreviewHoveringState;

  constructor({ store, id, kind }: { store: AppStore; id: string; kind: ItemListItemKind }) {
    this.store = store;
    this.id = id;
    this.kind = kind;

    this.hoveringOverTarget = new ItemPreviewHoveringState();
    this.hoveringOverPreview = new ItemPreviewHoveringState();

    makeAutoObservable(this, {
      visible: computed,
      previewUi: computed,
    });
  }

  get enabled() {
    return this.store.publicAppStore.interface.isHoverable && this.kind === ItemListItemKind.Note;
  }

  get visible() {
    return this.enabled && (this.hoveringOverTarget.hovering || this.hoveringOverPreview.hovering);
  }

  get note() {
    if (!this.visible || this.kind !== ItemListItemKind.Note) return;

    return this.store.notes.getNoteObservableById({ noteId: this.id });
  }

  get anchorPreviewAtTheEnd() {
    return this.store.publicAppStore.interface.isScreenNarrowForRegularNotePreviews;
  }

  get previewUi() {
    return <FloatingNotePreview noteObservable={this.note} state={this.hoveringOverTarget} />;
  }

  get handleMouseEnter() {
    if (!this.enabled) return undefined;
    return this.hoveringOverTarget.handleMouseEnter;
  }

  get handleMouseLeave() {
    if (!this.enabled) return undefined;
    return this.hoveringOverTarget.handleMouseLeave;
  }
}
